export default "/assets/7810a177777347f1.png"